import React, { useEffect, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Box, Flex, Stack, useBreakpointValue } from '@chakra-ui/react';
import Link from '@components/atoms/Link';
import SubMenu from '@components/molecules/SubMenu';
import HeaderFont from '@components/atoms/HeaderFont';
import { dataLayerClick } from '@helpers/dataLayerPush';

const Menu = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { strapiMenus } = useStaticQuery(graphql`
    query {
      strapiMenus(attributes: { slug: { eq: "main-menu" } }) {
        attributes {
          title
          slug
          items {
            data {
              attributes {
                title
                url
                children {
                  data {
                    attributes {
                      title
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const [links, setLinks] = useState([]);

  useEffect(() => {
    if (!strapiMenus.attributes.items.data.length) {
      return;
    }

    const mappedLinks = strapiMenus.attributes.items.data.map((parent) => {
      return {
        title: parent.attributes.title,
        url: parent.attributes.url,
        children: parent.attributes.children.data.map((sub) => {
          return {
            title: sub.attributes.title,
            url: sub.attributes.url
          };
        })
      };
    });

    setLinks(mappedLinks);
  }, [strapiMenus.attributes.items.data]);

  return (
    <Box as="section">
      <Box as="nav" pt={{ base: `6rem`, md: `0` }}>
        <Flex justify="space-between" wrap="nowrap">
          <Stack spacing="0" direction={{ base: `column`, md: `row` }}>
            {links.map((link) => {
              return link.children.length > 0 ? (
                <SubMenu
                  key={`${link.title}-${link.url}`}
                  title={link.title}
                  links={link.children}
                />
              ) : (
                <Link
                  key={`${link.title}-${link.url}`}
                  href={link.url}
                  lineHeight="1rem"
                  height={{ base: `3.5rem`, md: `5.125rem` }}
                  p={{ base: `0.688rem 0`, md: `2rem 1.5rem` }}
                  variant={{ base: `purpleSm`, md: `purple` }}
                  _focus={{
                    textDecoration: `none`
                  }}
                  _hover={{
                    textDecoration: `none`
                  }}
                  onClick={() => {
                    dataLayerClick({
                      event: `nav_menu`,
                      clickText: link.title,
                      clickUrl: link.url
                    });
                  }}>
                  {isMobile ? (
                    <HeaderFont
                      fontStyle="italic"
                      color="white"
                      fontWeight="900"
                      textTransform="uppercase"
                      fontSize="4xl"
                      lineHeight="1"
                      ml="2">
                      {link.title}
                    </HeaderFont>
                  ) : (
                    <Box>{link.title}</Box>
                  )}
                </Link>
              );
            })}
          </Stack>
        </Flex>
      </Box>
    </Box>
  );
};

export default Menu;
